import axios from "axios";
import * as mockData from "./mock";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let cachedContent = null;

export const fetchAllContent = async () => {
  if (cachedContent) return cachedContent;
  try {
    const res = await axios.get(`${API}/content`);
    cachedContent = res.data;
    return cachedContent;
  } catch (e) {
    console.warn("API unavailable, using mock data", e);
    return null;
  }
};

export const fetchSection = async (section) => {
  try {
    const res = await axios.get(`${API}/content/${section}`);
    return res.data;
  } catch (e) {
    return null;
  }
};

export const updateSection = async (section, data) => {
  const res = await axios.put(`${API}/content/${section}`, { data });
  return res.data;
};

export const seedContent = async () => {
  const res = await axios.post(`${API}/seed`);
  return res.data;
};

export const submitPickup = async (order) => {
  const res = await axios.post(`${API}/pickups`, order);
  return res.data;
};

export const getPickups = async (status) => {
  const params = status ? { status } : {};
  const res = await axios.get(`${API}/pickups`, { params });
  return res.data;
};

export const updatePickupStatus = async (orderId, status) => {
  const res = await axios.patch(`${API}/pickups/${orderId}/status`, { status });
  return res.data;
};

export const deletePickup = async (orderId) => {
  const res = await axios.delete(`${API}/pickups/${orderId}`);
  return res.data;
};

// Helper: Get content with fallback to mock
export const getContentWithFallback = (apiContent, section) => {
  if (apiContent && apiContent[section]) return apiContent[section];
  // Fallback to mock
  const mockMap = {
    hero: mockData.heroData,
    stats: mockData.stats,
    services: mockData.services,
    howItWorks: mockData.howItWorksSteps,
    whyChooseUs: mockData.whyChooseUs,
    stores: mockData.stores,
    pricing: mockData.pricingData,
    testimonials: mockData.testimonials,
    faqs: mockData.faqs,
    contact: {
      phone: mockData.PHONE,
      email: mockData.EMAIL,
      whatsapp: mockData.WHATSAPP_URL,
      instagram: mockData.INSTAGRAM,
      hours: "6 AM \u2013 9 PM, All Days",
      address: "Jaipur, Rajasthan",
    },
  };
  return mockMap[section] || null;
};
